import { axiosInstance, CustomResponseFormat } from "api";
import { Content_104_2_A } from "data/task/v1/104-2-A";

export default async function get_104_2_A_RawData(
  taskId: string,
  patientId: number
) {
  try {
    const response = (await axiosInstance.get("/activity/detail", {
      params: { tk: `${taskId}:${patientId}` },
    })) as CustomResponseFormat;
    if (response.code === 0) {
      const data = response.result;

      const activityId = parseInt(taskId.split("#")[1]);
      const activityStepId = parseInt(taskId.split("#")[2]);
      return {
        taskId: `104-2-A#${activityId}#${activityStepId}`,
        content: Content_104_2_A(
          activityId,
          activityStepId,
          `${data.name || ""} - ${activityStepId}단계: ${data.step || ""}`
        ),
      };
    } else {
    }
  } catch (error) {
    // 에러 핸들링
    console.error("Error in get_104_2_A_RawData:", error);
    throw error; // 또는 에러에 대한 처리를 진행할 수 있음
  }
}
